module.exports = __webpack_public_path__ + "static/media/21-10.c4d48f58.mp3";